import React from 'react';

import style from './onboard-cards.module.less';

/**
 * Renders a connected icon in the onboarding section
 * @param {object} props - Component props
 * @param {React.ReactNode} props.connectedIcon - The icon to display
 * @returns {React.ReactElement} The connected item component
 */
export const ConnectedItem = ({ connectedIcon }) => {
  return <div className={style['connected-icon']}>{connectedIcon}</div>;
};
